<template>
    <ul class="list-unstyled">
        <li v-for="email in emails">
            <a :href="`mailto:${email.email}`">{{ email.email }}</a>
            <label class="badge badge-info" style="font-size: 85%; font-weight: 400;" v-if="email.is_primary">Primary</label>
            <label class="badge badge-warning" style="font-size: 85%; font-weight: 400;" v-if="email.is_active == 0">Inactive</label>
            <label class="badge badge-default" style="font-size: 85%; font-weight: 400;" v-for="type in email.email_types">{{ type }}</label>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            emails: {
                type: Array,
                required: true,
            }
        },

        data() {
            return {

            }
        },

        watch: {

        },

        computed: {

        },

        methods: {

        },

        mounted() {

        }
    }
</script>
